(() => {
  const offer = document.querySelector('[data-coupon-offer]');
  if (!offer) return;
  const backdrop = offer.querySelector('[data-coupon-backdrop]');
  const dialog = offer.querySelector('[role="dialog"]');
  const openButton = offer.querySelector('[data-coupon-open]');
  const closeButtons = offer.querySelectorAll('[data-coupon-close]');
  const couponForm = offer.querySelector('form');
  if (couponForm) {
    couponForm.id = 'CouponForm';
    couponForm.action = couponForm.action.replace(/#.*$/, '#CouponForm');
  }
  let previousFocus;

  const focusable = () => [...dialog.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href]')];
  const open = () => {
    previousFocus = document.activeElement;
    backdrop.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => dialog.focus());
  };
  const close = () => {
    backdrop.hidden = true;
    document.body.style.overflow = '';
    document.body.classList.remove('coupon-modal-open');
    localStorage.setItem('len-coupon-dismissed', 'true');
    previousFocus?.focus?.();
  };

  const openModal = () => {
    document.body.classList.add('coupon-modal-open');
    open();
  };
  openButton.addEventListener('click', openModal);
  closeButtons.forEach(button => button.addEventListener('click', close));
  backdrop.addEventListener('click', event => { if (event.target === backdrop) close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;
    const items = focusable();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (document.activeElement === dialog) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  offer.querySelector('[data-coupon-copy]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    try {
      await navigator.clipboard.writeText(button.dataset.code);
      button.querySelector('span').textContent = 'Copied!';
    } catch {
      button.querySelector('span').textContent = button.dataset.code;
    }
  });

  const submitted = offer.querySelector('[data-coupon-success]:not([hidden])');
  if (submitted) {
    openModal();
  } else if (!localStorage.getItem('len-coupon-dismissed')) {
    // Don't interrupt on arrival — let the visitor browse first, then invite them
    // after 10s. Only once: dismissal (or submitting) is remembered in localStorage.
    setTimeout(openModal, 10000);
  }
})();
